import type { GridOptions } from '../../../components/ui/table';
import { commonGridOptions, commonTextFilterParams } from '../../../lib/agGridOptions';
import {
  GRID_PAGE_SIZE,
  GRID_PAGE_SIZE_SELECTOR,
} from '../../../components/shared/agGridCells';
import type { StorefrontUrlSubmissionRow } from '../models/types';

export { GRID_PAGE_SIZE, GRID_PAGE_SIZE_SELECTOR };

/**
 * Header-funnel filters are UI-only. `doesFilterPass` always returns true so AG Grid does not
 * hide rows client-side — the list POST (same payload as Merchants / Transaction Monitoring)
 * is the source of truth, matching Infinite Row Model behaviour.
 */
const passServerSideFilter = () => true;

export const STOREFRONT_URL_REVIEW_GRID_DEFAULT_COL_DEF = {
  suppressAutoSize: true,
  filter: {
    component: 'agTextColumnFilter',
    doesFilterPass: passServerSideFilter,
  },
  filterParams: {
    ...commonTextFilterParams,
    filterOptions: ['contains'],
  },
};

export const storefrontUrlReviewGridOptions = {
  ...commonGridOptions,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No submissions match the current filters.</span>',
} satisfies GridOptions<StorefrontUrlSubmissionRow>;
